<template>
  <section class="style-section">
    <div class="title-guide">模块图标</div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 200px; height: 200px" :src="url1" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">功能</div>
    <div class="content-guide">
      本模块用于建立等高现浇箱梁的单梁模型、折面梁格模型、空间网格模型。
      结构的承载力分析通常采用单梁模型，结构的应力精细分析则采用折面梁格模型、空间网格模型。
    </div>
    <div class="content-guide" style="font-weight: 600">
      本模块支持桥梁曲线布置、变宽布置，不支持斜交布置。
    </div>
    <div class="img-guide">
      <el-image
        class="size-img"
        style="width: 700px; height: 240px"
        :src="url2"
        :zoom-rate="1.2"
        :max-scale="1.5"
        :min-scale="0.2"
        :preview-src-list="srcList2"
        :initial-index="0"
        fit="cover"
      />
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">模块设计理念</div>
    <div class="content-guide">
      对于现浇箱梁来说，单梁模型的建立主要是输入截面尺寸麻烦。
      对于折面梁格和空间网格模型，则主要是分割后的截面定义非常麻烦。
      考虑采用数学几何的方式建立全截面坐标模型，然后再做竖向几何分割，
      就可以变成多个独立的截面坐标模型，大大降低了截面定义的难度。
      故可以考虑按设计图纸的方式去设计尺寸参数，然后让程序用数学几何的方法建立各种截面，
      这样就相当于告诉程序各部位尺寸参数，就可以根据需要选择完整截面还是分割截面，
      一套参数可以生成多种模型，大大提高了效率。
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">模块使用流程</div>
    <div class="content-guide">
      <div>本模块常规使用流程如下：</div>
      <li>定义孔跨布置——曲线桥梁引入路线文件</li>
      <li>定义桥面布置参数（桥面宽度布置）</li>
      <li>选择汽车荷载，输入人群荷载</li>
      <li>输入桥面铺装厚度</li>
      <li>选择桥梁的结构类型、腹板类型、桥面横坡形成</li>
      <li>填写需要的自动计算参数</li>
      <li>点击“自动计算箱梁参数”按钮，让程序根据已有参数匹配箱梁的所有参数</li>
      <li>根据需要调整箱梁结构各部位尺寸</li>
      <li>切换到“钢束尺寸”窗口，根据需要调整箱梁预应力钢束尺寸</li>
      <li>切换到“钢筋尺寸”窗口，根据需要调整钢筋尺寸参数</li>
      <li>切换到“导出设置”窗口，选择导出模型类型</li>
      <li>
        保存项目文件，然后导出mct文件，mct文件导入到Midas
        Civil后即可得到计算模型
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image
          class="size-img"
          style="width: 700px; height: 420px"
          :src="url3"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList3"
          :initial-index="0"
          fit="cover"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥梁基本参数</div>
    <div class="content-guide">
      <li>跨径组合</li>
      <div>
        根据自己的需要输入跨径组合，可以采用“3-30”、“20+20”、“29.94+30+30+29.94”这样的方式，多跨连接符号仅支持“+”和“-”。
      </div>
      <li>选择曲线时需要导入路线文件，路线文件格式详见相关说明。</li>
      <li>
        起点桩号——引入路线文件后，输入桥梁起点对应路线文件的桩号，程序将以该桩号为桥梁起点、结合路线文件计算桥梁各部位平面位置。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 260px; height: 123px" :src="url4" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥面布置</div>
    <div class="content-guide">
      <li>
        整幅、分幅——两者的区别主要在于模型中车道的计算和布置。选择整幅时，W6和W7如果输入0，
        则W5+W8作为一个行车道整体宽度按照规范中的对向行驶进行车道布置。车道布置考虑了偏载和居中两种工况。
      </li>
      <li>
        W1～W12——对应示意图各部位宽度。程序会将W1～W12的数值相加再考虑加宽值作为箱梁的顶面宽度。
      </li>
      <li>荷载Q1～Q6——该荷载为除桥面铺装以外作用在桥面的其他荷载。</li>
      <div>Q1对应W1、W12宽度范围内的荷载（如人行道护栏、防撞护栏自重），</div>
      <div>Q2对应W2、W11宽度范围内的荷载(如人行道板自重)，</div>
      <div>
        Q3对应W3、W10宽度范围内的荷载（如非机动车道铺装调平层除开等厚部分自重），
      </div>
      <div>Q4对应W4、W9宽度范围内的荷载（如快慢车道分隔带自重），</div>
      <div>
        Q5对应W5、W8宽度范围内的荷载（如主行车道铺装调平层除开等厚部分自重），
      </div>
      <div>
        Q6对应W6、W7宽度范围内的荷载（如中央分隔带自重、分幅时右侧护栏自重）。
      </div>
      <div>特别注意荷载Q1～Q6的单位为kPa，即kN/m2。</div>
      <li>
        路线中心线到梁板边缘距离L1——本参数用于曲线桥时梁板的横向定位，便于计算箱梁中心线位置（程序按考虑加宽后换算出的箱梁中心线进行建模）。
      </li>
      <li>
        箱梁名义高距路线中心线距离——当考虑采用“腹板变高”方式导出模型时，该参数用于计算箱梁顶面各点位置。
      </li>
      <li>桥面加宽参数：</li>
      <div>
        选择对应的公路等级及加宽类别，点击计算，程序会根据输入的路线文件自动进行计算，计算数值显示在文本框内。
      </div>
      <div>你也可以点击“+”按钮增加加宽位置，输入对应桩号的加宽值。</div>
      <div>加宽是按直线进行线性加宽</div>
      <li>桥面超高参数：</li>
      <div>
        当主窗体选择“腹板变高”时，程序生成的截面顶面是允许带横坡的，横坡值即为本表内容。
      </div>
      <div>
        选择设计时速和采用规范项，填写标准横坡（%）数值（设计高程位置比两边高，输入正值；设计高程位置比两边低，输入负值），点击计算，程序会自动计算横坡（设计高程位置比左侧或右侧高，横坡数值为负值，设计高程位置比左侧或右侧低，横坡数值为正值）。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image
          class="size-img"
          style="width: 700px; height: 237px"
          :src="url5"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList5"
          :initial-index="0"
          fit="fill"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">材料参数</div>
    <div class="content-guide">
      <li>混凝土标号——选择箱梁混凝土采用的标号</li>
      <li>预应力钢材——选择箱梁采用的预应力钢束型号</li>
      <li>预应力管道——选择箱梁预应力钢束采用的管道类型</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 204px; height: 123px" :src="url6" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥面活荷载</div>
    <div class="content-guide">
      <li>
        汽车荷载——可以选择公路-Ⅰ级和公路-Ⅱ级。城-A级等效公路-Ⅰ级，城-B级等效公路-Ⅱ级。
      </li>
      <li>
        人群荷载——考虑人行道宽度后的人群荷载，该值不考虑横向分布系数，不考虑人群荷载时输入0。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 171px; height: 123px" :src="url7" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥面铺装</div>
    <div class="content-guide">
      <li>
        沥青混凝土层厚度——输入桥面沥青混凝土层的厚度。
        模型中该厚度乘以行车道宽度及密度（按24kN/m3取值）作为桥面荷载施加在梁体上。
        另外该厚度也用于温度梯度计算。桥梁没有该层时请输入数值0。
      </li>
      <li>
        水泥混凝土层厚度——输入结构宽度范围内水泥混凝土层的厚度。
        模型中该厚度乘以桥梁全宽及密度（按26kN/m3取值）作为桥面荷载施加在梁体上。
        如果沥青混凝土厚度为0，则程序按水泥混凝土铺装以该厚度作为温度梯度计算参数。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 133px; height: 123px" :src="url8" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">箱梁基本参数</div>
    <div class="content-guide">
      <li>
        结构类型——有全预应力、预应力A类和普通钢筋3种类型，用于自动计算时匹配不同的箱梁参数。
      </li>
      <li>
        腹板类型——有直腹板和斜腹板2种类型，用于自动计算时匹配不同的箱梁参数。
      </li>
      <li>横坡形成</li>
      <div>
        腹板等高——选择后程序生成的单元截面采用Midas
        Civil自带截面，且箱梁顶面水平，不考虑横坡。
      </div>
      <div>
        腹板变高——选择后程序生成的单元截面采用自定义数值截面，箱梁顶面按“桥面布置”中输入的桥面横坡进行布置。
      </div>
      <div style="font-weight: 600">
        注意：由于采用“腹板等高”方式生成的模型是采用Midas
        Civil自带截面，在mct文件导入到Midas Civil中的时候，Midas
        Civil需要重新计算每一个截面的截面特性参数，故导入速度会非常慢！
        没有特殊要求的话，建议将桥面横坡设置为0，然后用“腹板变高”方式导出mct文件。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 172px; height: 123px" :src="url9" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">自动计算参数</div>
    <div class="content-guide">
      <li>指定箱梁高——勾选并输入数值后锁定模型中的箱梁高度</li>
      <li>指定箱室数——勾选并输入数值后锁定模型中的箱室个数</li>
      <li>指定腹板宽——勾选并输入数值后锁定模型中的腹板厚度</li>
      <li>腹板斜率——如果腹板类型选择“斜腹板”，则可以在这里设置腹板斜率</li>
      <li>翼缘宽度——输入数值后锁定模型中的箱梁翼缘宽度</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 354px; height: 123px" :src="url10" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">结构尺寸——立面</div>
    <div class="content-guide">
      <li>本部分填写箱梁立面图中纵向尺寸，包括端横梁和中横梁。</li>
      <li>各参数意义如下：</li>
      <div>L1——箱梁端部到支座中心线距离</div>
      <div>L2——端横梁底板倒角长度</div>
      <div>L3——端横梁顶板倒角长度</div>
      <div>H1——箱梁高度</div>
      <div>H2——端横梁底板倒角高度</div>
      <div>H3——端横梁顶板倒角高度</div>
      <div>L4——中横梁底板倒角长度</div>
      <div>L5——中横梁顶板倒角长度</div>
      <div>H4——中横梁底板倒角高度</div>
      <div>H5——中横梁顶板倒角高度</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 730px; height: 95px" :src="url11" :fit="fit" />
      </div>
      <el-scrollbar height="300">
        <div class="title-img">
          <el-image
            style="width: 640px; height: 310px"
            :src="url11a"
            :fit="fit"
          />
          <el-image
            style="width: 640px; height: 310px"
            :src="url11b"
            :fit="fit"
          />
        </div>
      </el-scrollbar>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">结构尺寸——平面</div>
    <div class="content-guide">
      <li>本部分填写箱梁平面图中纵向尺寸，包括端横梁和中横梁。</li>
      <li>各参数意义如下：</li>
      <div>L6——端横梁腹板加厚段长度</div>
      <div>L7——端横梁腹板倒角段长度</div>
      <div>G1——端横梁中腹板加厚段厚度</div>
      <div>G2——端横梁边腹板加厚段厚度</div>
      <div>L8——中横梁腹板加厚段长度</div>
      <div>L9——中横梁腹板倒角段长度</div>
      <div>G3——中横梁中腹板加厚段厚度</div>
      <div>G4——中横梁边腹板加厚段厚度</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 586px; height: 95px" :src="url12" :fit="fit" />
      </div>
      <el-scrollbar height="300">
        <div class="title-img">
          <el-image
            style="width: 640px; height: 310px"
            :src="url12a"
            :fit="fit"
          />
          <el-image
            style="width: 640px; height: 310px"
            :src="url12b"
            :fit="fit"
          />
        </div>
      </el-scrollbar>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">结构尺寸——跨中横断面</div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 725px; height: 172px" :src="url13" :fit="fit" />
      </div>
    </div>
    <div class="content-guide">
      <li>本部分填写箱梁跨中部位截面尺寸，各参数意义如下：</li>
      <li>腹板、顶底板部分：</li>
      <div>
        B1——边腹板厚度。注意箱梁采用斜腹板时，该厚度为水平方向上的厚度。
      </div>
      <div>B2——中腹板厚度。</div>
      <div>H6——底板厚度。</div>
      <div>H7——顶板厚度。</div>
      <li>悬臂翼缘部分：</li>
      <div>B3——箱梁外侧翼缘水平宽度。</div>
      <div>
        B4——外侧翼缘存在二次倒角时，转点到翼缘根部的水平距离。如果没有二次倒角，请填0.001。
      </div>
      <div>B5——边腹板斜率。</div>
      <div>H8——外侧翼缘端部高度。</div>
      <div>H9——外侧翼缘根部高度与端部高度的差值。</div>
      <div>
        H10——外侧翼缘存在二次倒角时，转点到翼缘根部的垂直距离。如果没有二次倒角，请填0.001。
      </div>
      <li>箱室间距部分：</li>
      <div>箱室个数——填写计划采用的箱室个数。</div>
      <div>
        B6——箱梁底面外缘到第一道中腹板距离。
        箱室数小于3时程序自行根据底面宽度计算该值，箱室数大于等于3时方采用表内数值。
        程序在计算中间腹板间距时按平均原则进行。
      </div>
      <li>箱室倒角部分：</li>
      <div>D1～D4——箱梁边腹板顶底板断面倒角宽度、高度。</div>
      <div>D5～D8——箱梁中腹板顶底板断面倒角宽度、高度。</div>
    </div>
    <div class="img-guide">
      <el-scrollbar height="300">
        <div class="title-img">
          <el-image
            style="width: 640px; height: 310px"
            :src="url13a"
            :fit="fit"
          />
          <el-image
            style="width: 640px; height: 310px"
            :src="url13b"
            :fit="fit"
          />
          <el-image
            style="width: 640px; height: 310px"
            :src="url13c"
            :fit="fit"
          />
          <el-image
            style="width: 640px; height: 310px"
            :src="url13d"
            :fit="fit"
          />
        </div>
      </el-scrollbar>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">结构尺寸——横梁、横隔板、支座</div>
    <div class="content-guide">
      <li>横梁参数意义如下：</li>
      <div>全长L——横梁的横桥向长度。</div>
      <div>起点L0——用于定位横梁横向起点位置，允许横梁超出箱梁底面宽度。</div>
      <div>HL1——横梁的厚度。</div>
      <div>HL2——横梁的高度。允许横梁高度大于箱梁高度。</div>
      <li>横隔板参数意义如下：</li>
      <div>GB1——跨中横隔板的厚度。</div>
      <div>GB2、GB3——跨中横隔板的倒角宽度、高度。</div>
      <div>
        横隔板位置——跨中横隔板中心距本跨起点线的路线桩号的绝对距离，
        多道横隔板时用“,”号分隔，但数值均为距本跨起点线的路线桩号的绝对距离，不是相互间距离。
        若不考虑跨中横隔板，则该位置信息需要删除，切记不能填写0。
      </div>
      <li>支座参数意义如下：</li>
      <div>
        支座位置——每一个支座之间的间距，以横梁左侧端部为起点进行计算。程序会根据间距个数自动换算支座个数。
      </div>
      <div>
        支座约束——每一个支座的约束类型（有4种，详见下方示意图），可以填写1～4。
        约束类型涉及到导出模型的边界条件是否正确，如果无把握正确填写，则建议尽量使用“刷新支座个数”计算分配的约束类型。
      </div>
      <div>
        刷新支座个数——调整了支座位置信息后，一定要点击本按钮，
        程序将重新计算支座个数并重新分配约束类型，否则导出的模型容易出现边界条件问题。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 739px; height: 264px" :src="url14" :fit="fit" />
        <el-scrollbar height="300">
          <div class="title-img">
            <el-image
              style="width: 640px; height: 310px"
              :src="url14a"
              :fit="fit"
            />
            <el-image
              style="width: 640px; height: 310px"
              :src="url14b"
              :fit="fit"
            />
            <el-image
              style="width: 640px; height: 310px"
              :src="url14c"
              :fit="fit"
            />
          </div>
        </el-scrollbar>
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">钢束尺寸——腹板束</div>
    <div class="content-guide">
      <li>
        现浇箱梁的腹板钢束通常都是按波浪形布置，故参数划分为以下几个部分：端部立面、端部平面和中间横梁段立面。
      </li>
      <li>端横梁部位（立面）</li>
      <div>部位——分边腹板和中腹板两类，中腹板参数用于所有的中间腹板。</div>
      <div>
        组数——同一道腹板内相同线型的钢束孔道数，用D1参数来确定横向间距。
      </div>
      <div>根数——单一孔道内的钢绞线根数</div>
      <div>D1——相同线型的钢束孔道水平距离</div>
      <div>L1——钢束张拉端距离箱梁端部的水平距离。</div>
      <div>L2——钢束张拉端水平段长度，本长度允许为0。</div>
      <div>L3——钢束张拉端倾斜段长度，本长度不允许为0，至少需要填0.01。</div>
      <div>H1——钢束张拉端距箱梁底面距离。</div>
      <div>H2——钢束边跨中间段距箱梁底面距离。</div>
      <div>R1——第1个转点半径，没有时可以填0。</div>
      <div>R2——第2个转点半径。</div>
      <li>两端位置——箱梁两端参数是独立的，通过本选择框进行切换。</li>
      <li>
        两端相同——勾选后会将腹板钢束起点端参数复制给终点端，包括立面参数和平面参数。
      </li>
      <li>通过“+”和“-”按钮可以增加和减少钢束数量。</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image
          style="width: 720px; height: 167px"
          :src="url15a"
          :fit="fit"
        />
        <el-image
          style="width: 640px; height: 310px"
          :src="url15_1"
          :fit="fit"
        />
      </div>
    </div>
    <div class="content-guide">
      <li>端横梁部位（平面）</li>
      <div>PL1——钢束张拉端直线段长度。</div>
      <div>PL2——钢束张拉端收紧段长度。</div>
      <div>
        PB1——边腹板对应左侧第一道钢束的横向内移值，中腹板对应左侧第一道钢束的横向外移值。
      </div>
      <div>PB2——钢束之间的横向间距。</div>
      <div>PR1——第1个转点半径，没有时可以填0。</div>
      <div>PR2——第2个转点半径。</div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image
          style="width: 720px; height: 142px"
          :src="url15b"
          :fit="fit"
        />
        <el-image
          style="width: 640px; height: 310px"
          :src="url15_2"
          :fit="fit"
        />
      </div>
    </div>
    <div class="content-guide">
      <li>中横梁部位（立面）</li>
      <div>L4——桥墩处钢束前一跨倾斜段水平长度</div>
      <div>L5——桥墩处钢束前一跨水平段长度</div>
      <div>L6——桥墩处钢束后一跨水平段长度</div>
      <div>L7——桥墩处钢束后一跨倾斜段水平长度</div>
      <div>H3——桥墩处前一跨中间段距箱梁底面距离。</div>
      <div>H4——桥墩处水平段距箱梁顶面距离。</div>
      <div>H5——桥墩处后一跨中间段距箱梁底面距离。</div>
      <div>R3——桥墩处钢束第1个转点半径。</div>
      <div>R4——桥墩处钢束第2个转点半径。</div>
      <div>R5——桥墩处钢束第3个转点半径。</div>
      <div>R6——桥墩处钢束第4个转点半径。</div>
      <div>
        注意控制水平段长度与转点半径关系，避免出现桥墩第2转点与第3转点圆曲线重合导致的钢束形状错误问题。
      </div>
      <li>
        中横梁编号——箱梁每一道中横梁处参数是独立的，通过本选择框进行切换。
      </li>
      <li>多跨相同——勾选后会将1号横梁部位腹板钢束参数复制给其他横梁处。</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image
          style="width: 720px; height: 151px"
          :src="url15c"
          :fit="fit"
        />
        <el-image
          style="width: 640px; height: 310px"
          :src="url15_3"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">钢束尺寸——顶板束</div>
    <div class="content-guide">
      <li>
        顶板钢束可以单独添加，但是边腹板和中腹板会同时布置。参数意义如下：
      </li>
      <div>部位——分边腹板和中腹板两类，中腹板参数用于所有的中间腹板。</div>
      <div>
        布跨——该钢束起终点的位置基准位置。
        由2个墩台号用“-”号相连，起点位置计算基准为第1个数字代表的墩台编号，终点位置计算基准为第2个数字代表的墩台编号。
      </div>
      <div>根数——单一孔道内的钢绞线根数</div>
      <div>YL1——顶板钢束起点端弯起段水平长度</div>
      <div>
        YL2——顶板钢束起点端弯起段转点到墩台（墩台编号为布跨中第1个数字代表的墩台编号）距离。
      </div>
      <div>
        YL3——顶板钢束墩台（墩台编号为布跨中第2个数字代表的墩台编号）到终点端弯起段转点距离。
      </div>
      <div>YL4——顶板钢束终点端弯起段水平长度</div>
      <div>YH1——顶板钢束起点端到箱梁顶面距离</div>
      <div>YH2——顶板钢束平直段到箱梁顶面距离</div>
      <div>YH3——顶板钢束终点端到箱梁顶面距离</div>
      <div>YR1——钢束第1个转点半径。</div>
      <div>YR2——钢束第2个转点半径。</div>
      <div>
        YB1——孔道与腹板基准线的横向水平距离。鼠标点击本单元格可以看到对应右侧示意图。
      </div>
      <div></div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 724px; height: 158px" :src="url16" :fit="fit" />
        <el-scrollbar height="300">
          <div class="title-img">
            <el-image
              style="width: 640px; height: 310px"
              :src="url16a"
              :fit="fit"
            />
            <el-image
              style="width: 640px; height: 310px"
              :src="url16b"
              :fit="fit"
            />
          </div>
        </el-scrollbar>
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">钢束尺寸——底板束</div>
    <div class="content-guide">
      <li>
        底板钢束可以单独添加，但是边腹板和中腹板会同时布置。参数意义如下：
      </li>
      <div>部位——分边腹板和中腹板两类，中腹板参数用于所有的中间腹板。</div>
      <div>
        布跨——该钢束起终点的位置基准位置。
        由2个墩台号用“-”号相连，起点位置计算基准为第1个数字代表的墩台编号，终点位置计算基准为第2个数字代表的墩台编号。
      </div>
      <div>根数——单一孔道内的钢绞线根数</div>
      <div>YL1——底板钢束起点端弯起段水平长度</div>
      <div>
        YL2——底板钢束起点端弯起段转点到墩台（墩台编号为布跨中第1个数字代表的墩台编号）距离。
      </div>
      <div>
        YL3——底板钢束墩台（墩台编号为布跨中第2个数字代表的墩台编号）到终点端弯起段转点距离。
      </div>
      <div>YL4——底板钢束终点端弯起段水平长度</div>
      <div>YH1——底板钢束起点端到箱梁底面距离</div>
      <div>YH2——底板钢束平直段到箱梁底面距离</div>
      <div>YH3——底板钢束终点端到箱梁底面距离</div>
      <div>YR1——钢束第1个转点半径。</div>
      <div>YR2——钢束第2个转点半径。</div>
      <div>
        YB1——孔道与腹板基准线的横向水平距离。鼠标点击本单元格可以看到对应右侧示意图。
      </div>
      <div></div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 724px; height: 158px" :src="url17" :fit="fit" />
        <el-scrollbar height="300">
          <div class="title-img">
            <el-image
              style="width: 640px; height: 310px"
              :src="url17a"
              :fit="fit"
            />
            <el-image
              style="width: 640px; height: 310px"
              :src="url17b"
              :fit="fit"
            />
          </div>
        </el-scrollbar>
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">钢筋尺寸</div>
    <div class="content-guide">
      <li>
        普通钢筋参数分主梁纵向抗弯钢筋和腹板抗剪箍筋2类。
        程序会根据跨中截面标准段和每一跨端部腹板变宽段作为正弯矩区和负弯矩区的划分。
      </li>
      <li>主梁抗弯钢筋</li>
      <div>
        纵向钢筋在高度方向上将钢筋分为4层，纵向上分为支座加强区与跨中常规区2类。
        参数包括各层钢筋的直径、间距、保护层厚度。
      </div>
      <li>主梁腹板抗剪钢筋</li>
      <div>
        横向箍筋则仅在纵向上分为支座加强区与跨中常规区2类。
        参数包括箍筋直径、肢数、桥长方向间距。
        注意箍筋肢数指的是单个腹板竖向钢筋根数，即一个箍筋算2肢。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 599px; height: 259px" :src="url18" :fit="fit" />
        <el-image
          style="width: 640px; height: 310px"
          :src="url18a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">导出设置</div>
    <div class="content-guide">
      <li>
        程序可以根据选择分别导出3种模型：单梁模型、折面梁格模型、空间网格模型
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 323px; height: 61px" :src="url19" :fit="fit" />
      </div>
    </div>
    <div class="content-guide">
      <li>选择折面梁格模型需要定义箱梁截面划分</li>
      <li>腹板翼缘划分宽度B——以腹板边缘线为基准左右侧考虑的腹板单元包含宽度</li>
      <li>分割数量——翼缘和箱室部分除开腹板段的分割数量。</li>
      <li>
        自动分割——点击本按钮后，程序将按上面设置好的参数进行断面分割，可以在右下角看到划分好的示意图。
        注意分割后表格内显示的节段长度必须大于0，如果小于0则需要减小腹板翼缘划分宽度B值，不然导出的模型会出错。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 249px; height: 316px" :src="url20" :fit="fit" />
        <el-image
          style="width: 640px; height: 310px"
          :src="url20a"
          :fit="fit"
        />
      </div>
    </div>
    <div class="content-guide">
      <li>选择空间网格模型需要定义箱梁截面划分</li>
      <li>腹板翼缘划分宽度B——以腹板边缘线为基准左右侧考虑的腹板单元包含宽度</li>
      <li>分割数量——翼缘和箱室部分除开腹板段的分割数量。</li>
      <li>
        自动分割——点击本按钮后，程序将按上面设置好的参数进行断面分割，可以在右下角看到划分好的示意图。
        注意分割后表格内显示的节段长度必须大于0，如果小于0则需要减小腹板翼缘划分宽度B值，不然导出的模型会出错。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 262px; height: 573px" :src="url21" :fit="fit" />
        <el-image
          style="width: 640px; height: 310px"
          :src="url21a"
          :fit="fit"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section>
    <div class="title-guide">其他参数</div>
    <div class="content-guide">
      <li>
        单元顺桥向划分最大长度——本参数用于控制单梁模型中单个纵向单元的最大长度。
      </li>
      <li>
        汽车荷载放大系数——采用单梁模型时，汽车荷载应力验算结果是采用截面横向平均值，
        与实际腹板位置应力集中情况不符，故这里提供一个放大系数让模型计算结果更符合实际情况。具体值由设计人员根据设计经验取定。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 227px; height: 81px" :src="url22" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section>
    <div class="title-guide">温度梯度荷载</div>
    <div class="content-guide">
      <li>
        当采用“腹板变高”方式考虑箱梁顶面横坡生成单梁模型时，
        由于单元截面顶面存在横坡不水平，而程序默认的温度梯度生成是按水平方式做的，
        会导致温度梯度计算失真。故程序制作了使用Midas Civil
        2019V2.2版以后推出的以截面形状为准的温度梯度方式。 使用方法如下：
      </li>
      <div>1.点击程序本按钮，生成温度梯度mct文件。</div>
      <div>
        2.正常导出模型并导入到Midas
        Civil中，找到精力荷载工况“温度梯度（升）”和“温度梯度（降）”，
        将里面的温度梯度荷载删除。
      </div>
      <div>
        3.打开“工具——MCT命令窗口”，打开刚才生成好的温度梯度mct文件，点击左下角“运行”按钮，完成后即可以查看到温度梯度荷载按截面顶面横坡倾斜了。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 229px; height: 63px" :src="url23" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <div style="height: 120px"></div>
</template>
<script>
export default {
  data() {
    return {
      url1: require("@/assets/png/unit4/1.png"),
      url2: require("@/assets/png/unit4/2.png"),
      url3: require("@/assets/png/unit4/3.png"),
      url4: require("@/assets/png/unit4/4.png"),
      url5: require("@/assets/png/unit4/5.png"),
      url6: require("@/assets/png/unit4/6.png"),
      url7: require("@/assets/png/unit4/7.png"),
      url8: require("@/assets/png/unit4/8.png"),
      url9: require("@/assets/png/unit4/9.png"),
      url10: require("@/assets/png/unit4/10.png"),
      url11: require("@/assets/png/unit4/11.png"),
      url11a: require("@/assets/png/unit4/11-1.png"),
      url11b: require("@/assets/png/unit4/11-2.png"),
      url12: require("@/assets/png/unit4/12.png"),
      url12a: require("@/assets/png/unit4/12-1.png"),
      url12b: require("@/assets/png/unit4/12-2.png"),
      url13: require("@/assets/png/unit4/13.png"),
      url13a: require("@/assets/png/unit4/13-1.png"),
      url13b: require("@/assets/png/unit4/13-2.png"),
      url13c: require("@/assets/png/unit4/13-3.png"),
      url13d: require("@/assets/png/unit4/13-4.png"),
      url14: require("@/assets/png/unit4/14.png"),
      url14a: require("@/assets/png/unit4/14-1.png"),
      url14b: require("@/assets/png/unit4/14-2.png"),
      url14c: require("@/assets/png/unit4/14-3.png"),
      url15a: require("@/assets/png/unit4/15a.png"),
      url15b: require("@/assets/png/unit4/15b.png"),
      url15c: require("@/assets/png/unit4/15c.png"),
      url15_1: require("@/assets/png/unit4/15-1.png"),
      url15_2: require("@/assets/png/unit4/15-2.png"),
      url15_3: require("@/assets/png/unit4/15-3.png"),
      url16: require("@/assets/png/unit4/16.png"),
      url16a: require("@/assets/png/unit4/16-1.png"),
      url16b: require("@/assets/png/unit4/16-2.png"),
      url17: require("@/assets/png/unit4/17.png"),
      url17a: require("@/assets/png/unit4/17-1.png"),
      url17b: require("@/assets/png/unit4/17-2.png"),
      url18: require("@/assets/png/unit4/18.png"),
      url18a: require("@/assets/png/unit4/18-1.png"),
      url19: require("@/assets/png/unit4/19.png"),
      url20: require("@/assets/png/unit4/20.png"),
      url20a: require("@/assets/png/unit4/20-1.png"),
      url21: require("@/assets/png/unit4/21.png"),
      url21a: require("@/assets/png/unit4/21-1.png"),
      url22: require("@/assets/png/unit4/22.png"),
      url23: require("@/assets/png/unit4/23.png"),
      fit: "fill",
      srcList2: [
        require("@/assets/png/unit4/2.png"),
        require("@/assets/png/unit4/2-1.png"),
        require("@/assets/png/unit4/2-2.png"),
      ],
      srcList3: [
        require("@/assets/png/unit4/3.png"),
        require("@/assets/png/unit4/3-1.png"),
        require("@/assets/png/unit4/3-2.png"),
        require("@/assets/png/unit4/3-3.png"),
      ],
      srcList5: [
        require("@/assets/png/unit4/5.png"),
        require("@/assets/png/unit4/5-1.png"),
      ],
    };
  },
};
</script>
